export class JwtDecode {
    static chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    static polyfill (input) {
      var str = String(input).replace(/=+$/, '')
      if (str.length % 4 === 1) {
        throw new Error("'atob' failed: The string to be decoded is not correctly encoded.")
      }
      for (
      // initialize result and counters
        var bc = 0, bs, buffer, idx = 0, output = '';
      // get next character
        buffer = str.charAt(idx++);
      // character found in table? initialize bit storage and add its ascii value;
        ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
        // and if not first of each 4 characters,
        // convert the first 8 bits to one ascii character
        bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
      ) {
        // try to find character in table (0-63, not found => -1)
        buffer = this.chars.indexOf(buffer)
      }
      return output
    }
    static atob (input) {
      if (window && window.atob) {
        return window.atob(input)
      }
      return this.polyfill(input)
    }
    static b64DecodeUnicode (str) {
      return decodeURIComponent(this.atob(str).replace(/(.)/g, function (m, p) {
        var code = p.charCodeAt(0).toString(16).toUpperCase()
        if (code.length < 2) {
          code = '0' + code
        }
        return '%' + code
      }))
    }
    static decodeToken (token, options) {
      options = options || {}
      const pos = options.header === true ? 0 : 1
      let input = token.split('.')[pos]
      var output = input.replace(/-/g, '+').replace(/_/g, '/')
      switch (output.length % 4) {
        case 0:
          break
        case 2:
          output += '=='
          break
        case 3:
          output += '='
          break
        default:
          throw new Error('Illegal base64url string!')
      }

      try {
        return JSON.parse(this.b64DecodeUnicode(output))
      } catch (err) {
        return JSON.parse(this.atob(output))
      }
    }
}



// WEBPACK FOOTER //
// ./src/common/jwtdecode.js